import classNames from 'classnames'
import React, { FC } from 'react'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { Grid } from '../Grid'
import {
  InvestmentStrategyItem,
  InvestmentStrategyItemProps,
} from '../InvestmentStrategyItem'

export interface InvestmentStrategiesProps {
  gaTrackingId?: string
  items: InvestmentStrategyItemProps[]
  title?: string
}

export const InvestmentStrategies: FC<InvestmentStrategiesProps> = ({
  gaTrackingId,
  items,
  title,
}) => (
  <Grid>
    <div
      className={classNames(
        'col-span-full',
        'sm:col-start-2 sm:col-span-4 sm:-mx-30',
        'md:col-start-1 md:col-span-full md:mx-0',
        'lg:col-start-2 lg:col-span-6 lg:-mx-30',
        'xl:col-start-2 xl:col-span-8',
        'xxl:col-start-3 xxl:col-span-10'
      )}
    >
      {!isNullOrWhiteSpace(title) && (
        <h2
          className={classNames(
            'w-240 mx-auto mb-45 font-h2 text-h2 text-center align-middle text-primary',
            'tb:w-auto',
            'sm:mb-60'
          )}
        >
          {title}
        </h2>
      )}

      {!!items?.length && (
        <div className="border-t border-neutral-light divide-y divide-neutral-light">
          {items.map((line, i) => (
            <InvestmentStrategyItem key={i} {...line} gaTrackingId={gaTrackingId} />
          ))}
        </div>
      )}
    </div>
  </Grid>
)
